<div class="row justify-content-center g-0">
  <div class="col-xs-12 col-sm-10 col-md-8 col-lg-6">
    @if(alert){
      <div class="alert alert-{{alert.type}}">{{alert.message}}</div>
    }    

    @if(!processing()){
      <form name="form" (ngSubmit)="false" [formGroup]="form" novalidate>
        <div class="d-flex justify-content-between">
          <h1>pools</h1>
          <select class="form-control ms-1 pointer input-sm seasonlist flex-shrink-1" formControlName="season" (change)="updatePools()">
            @for(selectableSeason of selectableSeasons; track selectableSeason.getId()){
              <option [ngValue]="selectableSeason">{{selectableSeason.getName()}}</option>
            }
          </select>
        </div>
      </form>
    } @else {
      <h2 class="text-center">
        <fa-icon [icon]=faSpinner [animation]="'spin'"></fa-icon>
      </h2>
    }
    
    @if(!searching()){
      <div class="mt-3">
        <table class="table mt-2">
          <tbody>
            @for(poolShell of poolShells;track poolShell){
            <tr class="pointer" (click)="linkToPool(poolShell)">
              <td>{{poolShell.name}}</td>
              <td>{{poolShell.nrOfUsers}}</td>
            </tr>
            }
          </tbody>
        </table>
      </div>
    } @else {
      <h2 class="text-center">
        <fa-icon [icon]=faSpinner [animation]="'spin'"></fa-icon>
      </h2>
    }  
</div>